"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
}
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var angular_1 = __importDefault(require("angular"));
var app = angular_1.default.module('mobx-angularjs', []);
var debounce = function (fn, ms) {
    if (ms === void 0) { ms = 0; }
    var timeoutId;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () { return fn.apply(_this, args); }, ms);
    };
};
var link = function ($scope) {
    var $$watchers = $scope.$$watchers || [];
    var debouncedDigest = debounce($scope.$digest.bind($scope), 0);
    var dispose = mobx_1.reaction(function () { return $$watchers.slice().map(function (watcher) { return watcher.get($scope); }); }, function () { return !$scope.$root.$$phase && debouncedDigest(); });
    $scope.$on('$destroy', dispose);
};
app.directive('mobxAutorun', function () { return ({
    restrict: 'A',
    scope: false,
    link: link
}); });
exports.default = app.name;



//////////////////
// WEBPACK FOOTER
// ./index.ts
// module id = 0
// module chunks = 0